import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { Routes } from '../../../utils';
import { useAuthContext } from '../../Auth/AuthProvider';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';
import { Loading, Error, DateTimePicker } from '../../_common';
import { Query } from '../../_common';
import {
    GET_LOAD_ALLOCATION,
    GET_LOAD_ALLOCATION_SUMMARY,
    GET_JOB_SUMMARY_INFO,
} from '../../../graphql/client/queries';
import { SAVE_TONNAGE } from '../../../graphql/client/mutations';
import {
    GetLoadAllocation,
    GetLoadAllocation_getLoadAllocation as loadAllocationData,
    GetJobSummaryInfo,
    GetJobSummaryInfo_getJobSummaryInfo as JobSummaryInfo,
} from '../../../types/schemaTypes';
import DailySandAllocationsFilter from '../../Filter/DailySandAllocationsFilter';
import DailySandAllocationsSummary from './DailySandAllocationsSummary';
import DailySandAllocationsTable from './DailySandAllocationsDetailsTable';
import DailyTonnageModal from './DailyTonnageModal';
import './DailySandAllocations.scss';
import { Dropdown } from 'react-bootstrap';
import {  ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper';
import moment from 'moment';
import { useMutation, useQuery } from '@apollo/client/react';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';

//let plannedLoadAllocationDetails = {};
//let actualLoadAllocationDetails = {};


const DailySandAllocations = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isSandAllocationSetTonnageEnabled = authContext.userHasPermission(PermissionEnum.SandAllocationSetTonnage);
    const [tabTitle, setTabTitle] = useState(document.title);
    const [jobName, setJobName] = useState('');
    const [sandFromDate, setSandFromDate] = useState<any>();


    const [showDownloadFilter, setShowDownloadFilter] = useState(false);
    const showDownloadFilterHandler = () => {
        setShowDownloadFilter(!showDownloadFilter);
    };
    const {jobId} = useParams()
    const jobIdVal:any = jobId

    const getUpdatedOn = () => {
        const now = new Date();
        const nowCst = new Date(now.toLocaleString('en-US', { timeZone: 'CST' }));
        let month: number | string = nowCst.getMonth() + 1;
        month = month < 10 ? `0${month}` : month;
        let date: number | string = nowCst.getDate();
        date = date < 10 ? `0${date}` : date;
        const year = nowCst.getFullYear();
        let hours = nowCst.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        let minutes: number | string = nowCst.getMinutes();
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        let seconds: number | string = nowCst.getSeconds();
        seconds = seconds < 10 ? `0${seconds}` : seconds;
        return `${month}/${date}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    };
    const [lastUpdatedOn, setLastUpdatedOn] = useState(getUpdatedOn());
    const [refreshed, setRefreshed] = useState(false);

    const refreshScreen = () => {
        setLastUpdatedOn(getUpdatedOn());
        setRefreshed(true);
    };

    const [showDailyTonnageModal, setShowDailyTonnageModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [selectedTab, setSelectedTab] = useState<'planned' | 'actual'>('planned');

    const [isEditMode, setIsEditMode] = useState(false);
    const [editedTons, setEditedTons] = useState<Record<string, number | null>>({});
    const [isSaving, setIsSaving] = useState(false);

    const today = new Date();
    const [fromDate, setFromDate] = useState(
        `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()} 00:00:00`,
    );
    const fourteenDaysFromToday = new Date();
    fourteenDaysFromToday.setDate(today.getDate() + 13);
    const [toDate, setToDate] = useState(
        `${fourteenDaysFromToday.getMonth() +
            1}-${fourteenDaysFromToday.getDate()}-${fourteenDaysFromToday.getFullYear()} 00:00:00`,
    );

    const changeDate = (e,previous: boolean) => {
        e.preventDefault();
        const tempFromDate = new Date(fromDate);
        const tempToDate = new Date(toDate);
        if (previous) {
            tempFromDate.setDate(tempFromDate.getDate() - 14);
            tempToDate.setDate(tempToDate.getDate() - 14);
        } else {
            tempFromDate.setDate(tempFromDate.getDate() + 14);
            tempToDate.setDate(tempToDate.getDate() + 14);
        }
        setFromDate(`${tempFromDate.getMonth() + 1}-${tempFromDate.getDate()}-${tempFromDate.getFullYear()} 00:00:00`);
        setToDate(`${tempToDate.getMonth() + 1}-${tempToDate.getDate()}-${tempToDate.getFullYear()} 00:00:00`);
    };

    const changeDateFilter = (date: string) => {
        if (moment.isMoment(date)) {
            const tempFromDate = new Date(date.valueOf());
            tempFromDate.setHours(0, 0, 0);
            if (tempFromDate && tempFromDate.toString() !== 'Invalid Date' && tempFromDate.getFullYear() > 1900) {
                const tempToDate = new Date(date);
                tempToDate.setDate(tempToDate.getDate() + 13);
                tempToDate.setHours(0, 0, 0);
                setFromDate(
                    `${tempFromDate.getMonth() + 1}-${tempFromDate.getDate()}-${tempFromDate.getFullYear()} 00:00:00`,
                );
                setSandFromDate(
                    `${tempFromDate.getMonth() + 1}-${tempFromDate.getDate()}-${tempFromDate.getFullYear()} 00:00:00`,
                );
                setToDate(`${tempToDate.getMonth() + 1}-${tempToDate.getDate()}-${tempToDate.getFullYear()} 00:00:00`);
                document.getElementById('DailySandAllocations-DateFilter-Container')?.click();
            }
        }
    };

    const dateList: string[] = [];
    const dateItem = new Date(fromDate);
    for (let i = 0; i < 14; i++) {
        dateList.push(
            `${dateItem.getMonth() + 1 < 10 ? `0${dateItem.getMonth() + 1}` : dateItem.getMonth() + 1}/${
                dateItem.getDate() < 10 ? `0${dateItem.getDate()}` : dateItem.getDate()
            }${[6, 0].includes(dateItem.getDay()) ? '|' : ''}`,
        );
        dateItem.setDate(dateItem.getDate() + 1);
    }

    const variables = {
        input: {
            jobId: parseInt(jobIdVal),
            fromDate: fromDate,
            toDate: toDate,
        },
    };

    const { data: jobSummaryInfoData } = useQuery<GetJobSummaryInfo>(GET_JOB_SUMMARY_INFO, {
        variables: { jobId: parseInt(jobIdVal) },
        fetchPolicy: 'network-only',
        skip: !jobIdVal || isNaN(parseInt(jobIdVal)),
    });

    const getJobSummaryMapKey = (
        lofaId: number,
        proppantId: number,
        sandPO: string,
        transportationPO: string,
    ) => `${lofaId}_${proppantId}_${sandPO}_${transportationPO}`;

    const jobSummaryIdMap: Record<string, number> = {};
    if (jobSummaryInfoData?.getJobSummaryInfo) {
        jobSummaryInfoData.getJobSummaryInfo.forEach((entry: JobSummaryInfo | null) => {
            if (entry && entry.jobSummaryId != null && entry.lofaId != null && entry.proppantId != null) {
                jobSummaryIdMap[
                    getJobSummaryMapKey(
                        entry.lofaId,
                        entry.proppantId,
                        entry.sandPo,
                        entry.transportationPo,
                    )
                ] = entry.jobSummaryId;
            }
        });
    }

    const formatDateForMutation = (dayIndex: number): string => {
        const d = new Date(fromDate);
        d.setDate(d.getDate() + dayIndex);
        // Pin to UTC midnight of the cell's calendar date so the ISO string
        // can't shift to a different day across timezones on the backend.
        return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
    };

    const [saveTonnageMutation] = useMutation(SAVE_TONNAGE, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: GET_LOAD_ALLOCATION,
                variables: variables,
            },
            {
                query: GET_LOAD_ALLOCATION_SUMMARY,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        date: `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`,
                    },
                },
            },
        ],
    });

    const handleEnterEditMode = () => {
        setEditedTons({});
        setIsEditMode(true);
    };

    const handleCancelEdit = () => {
        setEditedTons({});
        setIsEditMode(false);
    };

    const handleCellChange = (jobSummaryId: number, dayIndex: number, value: number | null) => {
        const key = `${jobSummaryId}_${dayIndex}`;
        setEditedTons((prev) => ({ ...prev, [key]: value }));
    };

    const handleSaveEdits = async () => {
        const entries = Object.keys(editedTons);
        if (entries.length === 0) {
            handleCancelEdit();
            return;
        }
        const grouped: Record<number, { jobsummaryId: number; tonnage: number }[]> = {};
        entries.forEach((key) => {
            const [jobSummaryIdStr, dayIndexStr] = key.split('_');
            const jobsummaryId = parseInt(jobSummaryIdStr);
            const dayIndex = parseInt(dayIndexStr);
            const value = editedTons[key];
            if (!Number.isFinite(jobsummaryId) || !Number.isFinite(dayIndex)) return;
            const tonnage = value == null || !Number.isFinite(value) ? 0 : (value as number);
            if (!grouped[dayIndex]) grouped[dayIndex] = [];
            grouped[dayIndex].push({ jobsummaryId, tonnage });
        });
        setIsSaving(true);
        try {
            const errorMessages: string[] = [];
            for (const dayIndexStr of Object.keys(grouped)) {
                const dayIndex = parseInt(dayIndexStr);
                const dateStr = formatDateForMutation(dayIndex);
                const result = await saveTonnageMutation({
                    variables: {
                        input: {
                            fromDate: dateStr,
                            toDate: dateStr,
                            tonnageDetails: grouped[dayIndex],
                        },
                    },
                });
                const responseErrors: (string | null)[] =
                    (result?.data as { saveTonnage?: { errors?: (string | null)[] } })?.saveTonnage?.errors ?? [];
                responseErrors.forEach((err) => {
                    if (err) errorMessages.push(err);
                });
            }
            if (errorMessages.length > 0) {
                toast.error(`Failed to update tonnage: ${errorMessages.join(', ')}`, toastOpt);
            } else {
                toast.success('Tonnage updated successfully', toastOpt);
                setEditedTons({});
                setIsEditMode(false);
            }
        } catch (e) {
            toast.error('Failed to update tonnage', toastOpt);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Query<GetLoadAllocation> query={GET_LOAD_ALLOCATION} variables={variables} fetchPolicy="network-only">
            {({ loading, error, data,  previousData, refetch }): React.ReactElement | null => {

                const [reCheck, setReCheck] = useState(false);
                if (error) {
                    return <Error error={error} />;
                }

                if (refreshed) {
                    refetch();
                }

                React.useEffect(()=>{
                    if (data?.getLoadAllocation && data.getLoadAllocation.length !== 0) {
                    const first = data.getLoadAllocation[0];
                    document.title = first?.jobName ?? tabTitle;
                    localStorage.setItem('Jobdetails-TabName', document.title);
                    setTabTitle(document.title);
                    setJobName(document.title);
                    }

                },[data, data?.getLoadAllocation, tabTitle])

                if(data === undefined && previousData){
                    data = previousData
                }
                const plannedLoadAllocationDetails = {};
                const actualLoadAllocationDetails = {};
                if (data?.getLoadAllocation && data.getLoadAllocation.length !== 0) {
                    (data.getLoadAllocation as (loadAllocationData | null)[]).forEach((element: loadAllocationData | null): void => {
                        if (element != null) {
                            if (element.type === 'Planned') {
                                if (element.proppantName in plannedLoadAllocationDetails) {
                                    const temp: loadAllocationData[] = plannedLoadAllocationDetails[element.proppantName];
                                    temp.push(element);
                                    plannedLoadAllocationDetails[element.proppantName] = temp;
                                } else {
                                    const temp: loadAllocationData[] = [];
                                    temp.push(element);
                                    plannedLoadAllocationDetails[element.proppantName] = temp;
                                }
                            }
                            if (element.type === 'Actual') {
                                if (element.proppantName in actualLoadAllocationDetails) {
                                    const temp: loadAllocationData[] = actualLoadAllocationDetails[element.proppantName];
                                    temp.push(element);
                                    actualLoadAllocationDetails[element.proppantName] = temp;
                                } else {
                                    const temp: loadAllocationData[] = [];
                                    temp.push(element);
                                    actualLoadAllocationDetails[element.proppantName] = temp;
                                }
                            }
                        }
                    });
                }
               

                return (
                    <div className="Messages-Container">
                        <div className="Messages-BodyContainer">
                            <DailySandAllocationsFilter
                                jobId={jobIdVal}
                                showDownloadFilter={showDownloadFilter}
                                showDownloadFilterHandler={showDownloadFilterHandler}
                            />
                        </div>

                        <div className="DailySandAllocations-Header-Container">
                            <div className="DailySandAllocations-Headers">
                                <i
                                    className="material-icons DailySandAllocations-Download-Icon"
                                    onClick={showDownloadFilterHandler}
                                >
                                    get_app
                                </i>
                                <div className="JobProfile-HeaderTitle DailySandAllocation-HeaderTitle">
                                    Daily Sand Allocations: {jobName}
                                </div>

                                <JobMenuItems jobId={jobId ?? "0"} menu='sandAllocation'/>
                            </div>

                            <div className="DailySandAllocation-Refresh-Container">
                                <button className="DailySandAllocations-Refresh-Button" onClick={refreshScreen}>
                                    <i className="material-icons DailySandAllocations-Refresh-Icon">refresh</i>
                                    Refresh
                                </button>
                                <div className="DailySandAllocations-Last-Update">Last Updated On:{lastUpdatedOn}</div>
                            </div>
                        </div>
                        <ToastContainer />
                        <div className="DailySandAllocationHeader">Allocation Summary</div>
                        <div className="DailySandAllocationSummaryTableContainer">
                            <DailySandAllocationsSummary
                                jobId={parseInt(jobIdVal)}
                                jobName={jobName}
                                date={`${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`}
                                refreshed={refreshed}
                                setRefreshed={setRefreshed}
                            />
                        </div>

                        <div className="DailySandAllocationHeader">Daily Sand Allocation Details</div>
                        {Object.keys(plannedLoadAllocationDetails).length !== 0 && (
                            <div className="DailySandAllocations-Tab-Button-Container">
                                <div className="DailySandAllocations-Tab-Container">
                                    <div
                                        className={`DailySandAllocations-Tab ${selectedTab === 'planned' &&
                                            'DailySandAllocations-TabSelected'}`}
                                    >
                                        <span
                                            className="DailySandAllocations-Tab-Text"
                                            onClick={(): void => {
                                                setSelectedTab('planned');
                                            }}
                                        >
                                            Planned
                                        </span>
                                    </div>

                                    <div
                                        className={`DailySandAllocations-Tab DailySandAllocations-Tab-With-Margin ${selectedTab ===
                                            'actual' && 'DailySandAllocations-TabSelected'}`}
                                    >
                                        <span
                                            className="DailySandAllocations-Tab-Text"
                                            onClick={(): void => {
                                                setSelectedTab('actual');
                                            }}
                                        >
                                            Actual
                                        </span>
                                    </div>

                                    {isSandAllocationSetTonnageEnabled ? (
                                        <>
                                            {!isEditMode && (
                                                <div
                                                    className="DailySandAllocations-Button"
                                                    onClick={() => setShowDailyTonnageModal(true)}
                                                >
                                                    <span className="DailySandAllocations-Seperator">|</span>
                                                    <span className="DailySandAllocations-Button-Text">
                                                        <i className="material-icons DailySandAllocations-Set-Icon">
                                                            add_circle
                                                        </i>
                                                        Set Daily Tonnage
                                                    </span>
                                                </div>
                                            )}
                                            {selectedTab === 'planned' && !isEditMode && (
                                                <div
                                                    className="DailySandAllocations-Button"
                                                    onClick={handleEnterEditMode}
                                                >
                                                    <span className="DailySandAllocations-Seperator">|</span>
                                                    <span className="DailySandAllocations-Button-Text">
                                                        <i className="material-icons DailySandAllocations-Set-Icon">
                                                            edit
                                                        </i>
                                                        Edit Tons
                                                    </span>
                                                </div>
                                            )}
                                            {selectedTab === 'planned' && isEditMode && (
                                                <>
                                                    <div
                                                        className="DailySandAllocations-Button"
                                                        onClick={() => {
                                                            if (!isSaving) handleSaveEdits();
                                                        }}
                                                    >
                                                        <span className="DailySandAllocations-Seperator">|</span>
                                                        <span className="DailySandAllocations-Button-Text">
                                                            <i className="material-icons DailySandAllocations-Set-Icon">
                                                                save
                                                            </i>
                                                            {isSaving ? 'Saving...' : 'Save'}
                                                        </span>
                                                    </div>
                                                    <div
                                                        className="DailySandAllocations-Button"
                                                        onClick={() => {
                                                            if (!isSaving) handleCancelEdit();
                                                        }}
                                                    >
                                                        <span className="DailySandAllocations-Seperator">|</span>
                                                        <span className="DailySandAllocations-Button-Text">
                                                            <i className="material-icons DailySandAllocations-Set-Icon">
                                                                close
                                                            </i>
                                                            Cancel
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                <div className="DailySandAllocations-FilterPrevNext-Container">
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="outline-dark"
                                            id="DailySandAllocations-DateFilter-Container"
                                        >
                                            <span className="DailySandAllocations-DateFilter-Text">
                                                {`${fromDate.split(' ')[0].replaceAll('-', '/')} -
                                                     ${toDate.split(' ')[0].replaceAll('-', '/')}`}
                                            </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="DailySandAllocations-DateFilter-Dropdown-Container">
                                            <div className="DailySandAllocations-DateFilter-Dropdown">
                                                <DateTimePicker
                                                    dateOnly
                                                    label="Choose FROM date"
                                                    onChange={value => changeDateFilter(value)}
                                                    error={''}
                                                    value={sandFromDate}
                                                    open={true}
                                                />
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    <div className="DailySandAllocations-PrevNext-Container">
                                        <div
                                            className="DailySandAllocations-Button DailySandAllocations-Prev-Button"
                                            onClick={(e) => {
                                                changeDate(e,true);
                                            }}
                                        >
                                            <span className="DailySandAllocations-Button-Text">
                                                <i className="material-icons">chevron_left</i>
                                                Previous
                                            </span>
                                        </div>

                                        <div
                                            className="DailySandAllocations-Button"
                                            onClick={(e) => {
                                                changeDate(e,false);
                                            }}
                                        >
                                            <span className="DailySandAllocations-Button-Text">
                                                Next
                                                <i className="material-icons">chevron_right</i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="DailySandAllocationsTables-Container">
                            
                            {loading && (
                                <div className="DailySandAllocations-Spinner-Container">
                                    <Loading />
                                </div>
                            )}

                            {selectedTab === 'planned' && Object.keys(plannedLoadAllocationDetails).length !== 0 && (
                                <DailySandAllocationsTable
                                    dateList={dateList}
                                    loadAllocationDetails={plannedLoadAllocationDetails}
                                    loading={loading}
                                    isEditMode={isEditMode}
                                    editedTons={editedTons}
                                    jobSummaryIdMap={jobSummaryIdMap}
                                    onCellChange={handleCellChange}
                                />
                            )}

                            {selectedTab === 'actual' && Object.keys(actualLoadAllocationDetails).length !== 0 && (
                                <DailySandAllocationsTable
                                    dateList={dateList}
                                    loadAllocationDetails={actualLoadAllocationDetails}
                                    loading={loading}
                                />
                            )}

                            {Object.keys(plannedLoadAllocationDetails).length == 0 && !loading && (
                                <div className="NoResult-Second-Title-Primary">No Sand Allocations Details found.</div>
                            )}
                        </div>

                        {showDailyTonnageModal && (
                            <DailyTonnageModal
                                show={showDailyTonnageModal}
                                onClickHide={() => setShowDailyTonnageModal(false)}
                                errorMessage={errorMessage}
                                jobId={parseInt(jobIdVal)}
                            />
                        )}
                    </div>
                );
            }}
        </Query>
    );
};

export default DailySandAllocations;
